// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PrimaryKeyRequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {StakeholderAddress} from './StakeholderAddress';
import {ProjectStakeholderRelationship} from './ProjectStakeholderRelationship';

const _associations = [
			{
				name: 'StakeholderAddresses',
				model: new StakeholderAddress(),
				type: 'ArrayOfChildren',
				using: 'stakeholderId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: 'Address',
				groupTitle: 'Address',
				displayOrder: 7,
				itemTitle: 'Address',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ProjectStakeholderRelationship',
				model: new ProjectStakeholderRelationship(),
				type: 'ArrayOfChildren',
				using: 'stakeholderId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Projects',
				groupTitle: 'Project Relationships',
				displayOrder: 10,
				itemTitle: 'Project Relationship',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: 'StreamBankProjectStakeholderList',
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'stakeholderId',
				placeholder: null,
				key: 'stakeholderId',
				isPrimaryKey: true,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.stakeholderId,
				setter: (x, y) => x.stakeholderId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new PrimaryKeyRequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Visible to Organization',
				placeholder: null,
				key: 'organizationId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: ["skips_data_segmentation","authenticated_user"]
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: ["skips_data_segmentation","authenticated_user"],
				group: 'General',
				groupTitle: 'General',
				displayOrder: 5,
				getter: (x) => x.organizationId,
				setter: (x, y) => x.organizationId = y,
				defaultValue: null,
				editor: 'OrganizationFieldEditor',
				viewer: 'OrganizationFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Contact Type',
				placeholder: null,
				key: 'stakeholderTypeId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 1,
				getter: (x) => x.stakeholderTypeId,
				setter: (x, y) => x.stakeholderTypeId = y,
				defaultValue: null,
				editor: 'StakeholderTypeEditor',
				viewer: 'StakeholderTypeViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'First Name',
				placeholder: null,
				key: 'firstName',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: {
					query: 'to_number(stakeholderTypeId) != `1`',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 2,
				getter: (x) => x.firstName,
				setter: (x, y) => x.firstName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Middle Name',
				placeholder: null,
				key: 'middleName',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: {
					query: 'to_number(stakeholderTypeId) != `1`',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 3,
				getter: (x) => x.middleName,
				setter: (x, y) => x.middleName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Last Name',
				placeholder: null,
				key: 'lastName',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: {
					query: 'to_number(stakeholderTypeId) != `1`',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 4,
				getter: (x) => x.lastName,
				setter: (x, y) => x.lastName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Name',
				placeholder: null,
				key: 'organizationName',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: {
					query: 'to_number(stakeholderTypeId) != `2`',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 2,
				getter: (x) => x.organizationName,
				setter: (x, y) => x.organizationName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'CRM ID',
				placeholder: null,
				key: 'crmId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				getter: (x) => x.crmId,
				setter: (x, y) => x.crmId = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Preferred Contact Method',
				placeholder: null,
				key: 'preferredContactMethodId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 5,
				getter: (x) => x.preferredContactMethodId,
				setter: (x, y) => x.preferredContactMethodId = y,
				defaultValue: null,
				editor: 'ContactMethodFieldEditor',
				viewer: 'ContactMethodFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Preferred Time of Day',
				placeholder: null,
				key: 'preferredContactTime',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 6,
				getter: (x) => x.preferredContactTime,
				setter: (x, y) => x.preferredContactTime = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Follow Up Actions',
				placeholder: null,
				key: 'followUpActions',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Notes',
				groupTitle: 'Notes',
				displayOrder: 10,
				getter: (x) => x.followUpActions,
				setter: (x, y) => x.followUpActions = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(2000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Notes',
				placeholder: null,
				key: 'notes',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Notes',
				groupTitle: 'Notes',
				displayOrder: 11,
				getter: (x) => x.notes,
				setter: (x, y) => x.notes = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(2000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deletedKey',
				placeholder: null,
				key: 'deletedKey',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deletedKey,
				setter: (x, y) => x.deletedKey = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Display Name',
				placeholder: null,
				key: 'displayName',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.displayName,
				setter: (x, y) => x.displayName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'defaultEmail',
				placeholder: null,
				key: 'defaultEmail',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.defaultEmail,
				setter: (x, y) => x.defaultEmail = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class Stakeholder extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [
			new validators.DuplicateContactValidator(),
		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
